import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const popoverStyles = {
  zIndex: 1200,
};

export const endIconWrapperStyles = {
  display: 'inline-flex',
  color: 'gray.extraSoft',
};

// Dark: the dropdown panel is a dark elevated surface (per the design handoff), not the brand-blue
// used on the light header.
const getPopoverBg = (palette, isVertical) => {
  if (isVertical) {
    return palette.background.primary;
  }

  if (palette.mode === 'dark') {
    return palette.background.paper;
  }

  return palette.primary.main;
};

// Top-header nav items are contained (brand-blue) buttons in light — which read as a text-link bar on
// the brand-blue header. On the DARK header that blue fill is glaring, so in dark they become
// transparent text-links: dimmed label, brighter on hover, and an accent underline when active.
const getNavItemColor = (palette, isVertical) => {
  if (isVertical) {
    return palette.text.dark;
  }

  if (palette.mode === 'dark') {
    return palette.text.secondary;
  }

  return palette.common.white;
};

const getNavHoverColor = palette =>
  palette.mode === 'dark' ? palette.text.primary : palette.common.white;

const getNavItemBackground = palette =>
  palette.mode === 'dark' ? 'transparent' : palette.primary.main;

const getNavActiveBackground = palette =>
  palette.mode === 'dark' ? 'transparent' : palette.primary.dark;

export const getPopoverPaperStyles = ({ isVertical }) => ({
  padding: '12px',
  top: 'var(--app-header-height, 80px) !important',
  maxHeight: 'calc(100vh - 100px)',
  maxWidth: '300px',
  borderRadius: '0 0 8px 8px',
  backgroundColor: ({ palette }) => getPopoverBg(palette, isVertical),
});

export const getButtonStyles = ({ isVertical }) => ({
  padding: '10px 14px',
  textDecoration: 'none !important',
  textTransform: 'none',
  color: ({ palette }) => `${getNavItemColor(palette, isVertical)} !important`,
  font: ({ typography }) => typography.medium16,
  height: 'unset',
  // Center the label both ways so multi-line items (e.g. "Document Extraction") sit centered.
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',

  ...getConditionalObject(!isVertical, {
    backgroundColor: ({ palette }) => `${getNavItemBackground(palette)} !important`,

    '&:hover': {
      backgroundColor: ({ palette }) => `${getNavActiveBackground(palette)} !important`,
      color: ({ palette }) => `${getNavHoverColor(palette)} !important`,
    },

    '&[data-is-active="true"]': {
      backgroundColor: ({ palette }) => `${getNavActiveBackground(palette)} !important`,
      color: ({ palette }) => `${getNavHoverColor(palette)} !important`,
      borderBottom: ({ palette }) =>
        palette.mode === 'dark' ? `2px solid ${palette.primary.main}` : 'none',
    },
  }),

  ...getConditionalObject(isVertical, {
    padding: '12px 16px',
    justifyContent: 'space-between',

    color: ({ palette }) => `${palette.text.dark} !important`,
    backgroundColor: 'transparent !important',
    borderRadius: '8px',

    '&:hover': {
      backgroundColor: `${COLOR_PALETTE.BRAND[1]} !important`,
    },

    '&[data-is-active="true"]': {
      color: ({ palette }) => `${palette.text.link} !important`,
      backgroundColor: `${COLOR_PALETTE.BRAND[1]} !important`,
    },
  }),
});
